import React  from 'react';
import { UserDetails } from '../../redux/actions/authActions';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Typography} from '@mui/material';
import './Styles.scss';

function HomeComp() {
  const { loading, error,message,user,isLoggedIn,auth_token } = useSelector((state) => state.auth);
  console.log("user",user)
  return (
    <Box className="rightContainer">
            <Typography component="h1" variant="h5" mb={2}>
            Welcome to {user ?user.firstName+" "+user.lastName:""}
            </Typography>
    </Box>
    
  );
}

export default HomeComp;
